import { FeatureFlagService } from '@application/feature_flags/feature_flag.service';
import { PlatformService } from '@application/platform.service';
import { UniversalConfig } from '@application/universal_config.service';
import { useResolve } from '@visiba/instantiation';
import { hasEndToEndEncryptionSupport } from './has_end_to_end_encryption_support.module';
import { useConstant } from '@visiba/react-std';

export function useVonageEncryptionWarning() {
	const universalConfig = useResolve(UniversalConfig);
	const platformService = useResolve(PlatformService);
	const featureFlagService = useResolve(FeatureFlagService);
	const appConfig = universalConfig.appConfig;
	const platform = platformService.parseAgentData().platform;
	const appDownloadUrl = useConstant(() => {
		if (appConfig && platform.android) {
			return `https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=${appConfig.androidPackageId}`;
		}
		if (appConfig && platform.ios) {
			return `https://itunes.apple.com/se/app/id${appConfig.appStoreId}`;
		}

		return null;
	});

	return {
		platform: platformService.parseAgentData().platform,
		appConfig: appConfig
			? {
					androidPackageId: appConfig.androidPackageId,
					appStoreId: appConfig.appStoreId,
					appDownloadUrl: appDownloadUrl,
				}
			: null,
		hasEncryptionSupport: featureFlagService.checkFlag('PatientWeb.UseVonage') && hasEndToEndEncryptionSupport(),
	};
}
